import React from 'react';

import { S3_BUCKET_URL } from '@/constants.ts';
import { useOnboarding } from '@/pages/Onboarding/context';
import { neckBreathSceneChoices } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/choicePanelOptions';
import { GenericScreenLayout } from '@/pages/Onboarding/Layouts/OwnAiMan_Roleplay/GenericScreenLayout';

export const NeckBreathScreen: React.FC = () => {
  const { wizard } = useOnboarding();

  const handleNextStep = () => {
    wizard.nextStep();
  };

  return (
    <GenericScreenLayout
      backgroundImage={`${S3_BUCKET_URL}/layout-own-ai-man-roleplay/neck-breath-scene.png`}
      title={[{ text: 'Breath on your neck.', italic: true }]}
      choices={neckBreathSceneChoices.map((option) => ({
        ...option,
        onClick: handleNextStep,
      }))}
    />
  );
};
